/*
 *  Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
 *  is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
 *  and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
 *
 *  You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
 *  in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
 *  forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
 *  explicitly covering such access.
 *
 *  The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
 *  which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
 *
 *  ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
 *  CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
 *  INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
 *  OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
 *  THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.
 *
 */

import React, { CSSProperties, useEffect, useMemo, useRef, useState } from 'react'
import moment from 'moment'
import { Input, Tag, Radio, Dropdown, Button, Menu, Modal, Form, Select, DatePicker, TimePicker } from 'antd'
import {useSelector, useDispatch} from 'react-redux'
import DeviceCard,{DeviceCardList} from './DeviceCard'

import './camera-finder.less'
import { FacebookOutlined, FilterOutlined, SortDescendingOutlined } from '@ant-design/icons'
import { DeviceTypeOptions, HealthOptions, StatusOptions } from '../../constants/device'
import UploadModal from './UploadModal'

const styleLabel = (labelText: string, style: CSSProperties={}) => {
  return (
    <span style={{fontSize: '16px',fontFamily: 'SanomatGrabApp', color: '#000000',...style}}>{labelText}</span>
  )
}


const CameraFinder = props => {

  const {onChange, defaultValue} = props

  const [visible, setVisible] = useState(false)
  const searchInput = useRef(null)
  const {cameras:{uploadingCamera,cameraList}} = useSelector(({cameras})=>({cameras}))
  const {cameras:{updateUploadingCamera}} = useDispatch()
  const [filterForm] = Form.useForm();
  useEffect(() =>{
    if( searchInput.current && defaultValue !== null ){
        searchInput.current.input.value =  defaultValue
    }
  })
  const handleFilterModal = (type)=>{
    if(type === 'ok'){
      updateUploadingCamera(null)
      const payload = filterForm.getFieldsValue()
      onChange({type: 'filter',payload})
    }
    setVisible(!visible)
  }
  const handleUploadModalChange = (action)=>{
    const {type, payload} = action
    switch (type){
      case 'cancel':
        updateUploadingCamera(null)
        break
      case 'ok':
        onChange({type:'upload',payload})
        break
      default: break
    }
  }
  const handleFilter = (deviceID) => {
    onChange({type: 'filter',payload: {deviceID}})
  }

  const handleMenuClick = (event)=>{
    const {key} = event
    onChange({type: 'filter',payload:{sortBy: key,order:'desc'}})
  }
  const menu = useMemo(()=>(
    <Menu onClick={handleMenuClick}>
      <Menu.Item key={'online_time'}>
          Latest Online Date
      </Menu.Item>
      <Menu.Item key={'total_image_count'}>
          Most Stored Images
      </Menu.Item>
    </Menu>
  ),[])
  const initialValues = useMemo(()=>({
    uploadTime: [moment().hour(9).minute(0).seconds(0), moment().hour(18).minute(0).seconds(0)]
  }),[])

  return (
    <div className={'camera-finder-container'}>
      <div className={'search'}>
        <Input.Search
          placeholder={'search with device id'}
          allowClear={true}
          enterButton={true}
          ref={searchInput}
          onSearch={handleFilter}
          style={{width:'330px'}}
        />
      </div>
      <div className={'neck'}>
        <span style={{opacity: cameraList.length >0 ? 1 : 0}}>1-{cameraList.length} of {cameraList.length}</span>
        <div className={'operation'} >
          <Tag icon={<FilterOutlined />} className={'filter'} onClick={handleFilterModal}>Filter</Tag>
          <Dropdown overlay={menu} className={'sort-by'} placement="bottomLeft" arrow>
            <Tag icon={<SortDescendingOutlined />}>Sort by</Tag>
          </Dropdown>
        </div>
      </div>
      <div className={'list'}>
        <DeviceCardList/>
      </div>
      <Modal
        visible={visible}
        centered
        title={styleLabel('Filters',{color:'#262626'})}
        width={392}
        cancelText={null}
        onCancel={handleFilterModal.bind(null,'cancel')}
        footer={[
          <Button key="back" onClick={handleFilterModal.bind(null,'ok')} type={'primary'}>
            Apply
          </Button>]}
      >
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          labelAlign={'left'}
          form={filterForm}
        >
          <Form.Item label={styleLabel('Health Track')} name="status">
            <Select options={HealthOptions} />
          </Form.Item>
          <Form.Item label={styleLabel("Status")} name="onlineStatus">
            <Select options={StatusOptions} />
          </Form.Item>
          <Form.Item label={styleLabel("Device Type")} name="deviceType">
            <Select options={DeviceTypeOptions} />
          </Form.Item>
        </Form>
      </Modal>
      <UploadModal
        title={'Create Upload Task' + '-' + uploadingCamera?.deviceID}
        validateInfo ={uploadingCamera}
        visible={uploadingCamera !== null}
        onChange={handleUploadModalChange}
        okText={'Create an Upload Task'}
        initialValues={initialValues}
      />
    </div>
  )
}
export {
  CameraFinder as default
}
